/**
 * 2n4uMember가 공통 동의 처리를 요구했다고 명시적으로 반환한 경우만 인식합니다.
 * mioSegno는 오류 문구나 version 문자열을 해석해 재동의 여부를 자체 판단하지 않습니다.
 */
export function requiresCommonReconsent(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false

  const code = 'code' in error && typeof error.code === 'string'
    ? error.code.toUpperCase()
    : ''

  return [
    'COMMON_CONSENT_REQUIRED',
    'COMMON_CONSENTS_REQUIRED',
    'COMMON_TERMS_RECONSENT_REQUIRED',
    'TERMS_RECONSENT_REQUIRED',
  ].includes(code)
}
